import { Platform } from "@/types";

interface UserAgentData {
  platform?: string;
  mobile?: boolean;
}
interface NavigatorWithUA extends Navigator {
  userAgentData?: UserAgentData;
}

// Best-effort detection of the user's current OS for sensible KB
// pre-filtering. Returns null if we can't tell — UI then defaults to "All".
export function detectPlatform(): Platform | null {
  const nav = navigator as NavigatorWithUA;
  const uaData = nav.userAgentData;
  if (uaData?.platform) {
    const p = uaData.platform.toLowerCase();
    if (p.includes("mac")) return "macos";
    if (p.includes("windows")) return "windows";
    if (p.includes("linux")) return "linux";
    if (p.includes("android")) return "android";
    if (p.includes("ios") || p.includes("iphone") || p.includes("ipad")) return "ios";
  }
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return "ios";
  if (/android/.test(ua)) return "android";
  if (/mac os x|macintosh/.test(ua)) return "macos";
  if (/windows nt|win32|win64/.test(ua)) return "windows";
  if (/linux/.test(ua)) return "linux";
  return null;
}
